<ng-container *ngIf="initialized">
  <form #theForm="ngForm" class="form" (ngSubmit)="apply()" novalidate>
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Apply</h5>
      </div>
      <div *ngIf="!auth.isLoggedIn()" class="p-2">
        <h5>You are currently logged out. Please login or create an account.</h5>
      </div>
      <div class="modal-body" *ngIf="auth.isLoggedIn()">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="exampleFormControlInput1">First Name</label>
              <input type="text" [(ngModel)]="formData.firstName" name="firstName" class="form-control" required />
              <div class="invalid-message">
                <div>First Name is required</div>
              </div>
            </div>
            <div class="form-group">
              <label for="exampleFormControlInput1">Last Name</label>
              <input type="text" [(ngModel)]="formData.lastName" name="lastName" class="form-control" required />
              <div class="invalid-message">
                <div>Last Name is required</div>
              </div>
            </div>
            <div class="form-group">
              <label for="exampleFormControlInput1">Email Address</label>
              <input type="email" [(ngModel)]="formData.emailAddress" name="emailAddress" class="form-control" email pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" required />
              <div class="invalid-message">
                <div>A valid Email Address is required</div>
              </div>
            </div>
            <div class="form-group">
              <label for="exampleFormControlInput1">Phone Number</label>
              <input type="text" [(ngModel)]="formData.phoneNumber" name="phoneNumber" class="form-control" />
            </div>
            <div class="form-group">
              <label for="exampleFormControlInput1">Cover Letter</label>
              <ckeditor [editor]="Editor" [(ngModel)]="formData.coverLetter" name="coverLetter" [config]="htmlEditorConfig" style="width: 100%"></ckeditor>
            </div>
            <h6>Upload your Resume</h6>
            <azure-file-upload [isRequired]="true" class="d-block" #resumeUploader name="resumeUploader" [(ngModel)]="formData.resumeAssetPath" [azureContainer]="'job-applications'" [acceptedFileTypes]="['application/pdf']"></azure-file-upload>
            <div class="invalid-message">
                <div *ngIf="theForm.controls.resumeUploader?.errors?.isRequired">Resume is required</div>
              </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="d-flex justify-content-end w-100">
          <button class="btn btn-sm btn-secondary mr-2" (click)="showLogin()" *ngIf="!auth.isLoggedIn()" type="button">
            <span>Login / Sign Up</span>
          </button>
          <button class="btn btn-sm btn-admin-primary mr-2" [promiseBtn]="submitComplete" type="submit" *ngIf="auth.isLoggedIn()">
            <span>Apply</span>
          </button>
          <button class="btn btn-sm btn-outline-dark" (click)="onCancel()" type="button">Cancel</button>
        </div>
      </div>
    </div>
  </form>
</ng-container>
